import React from "react";
import './UploadTicketImages.css'

interface UploadTicketImagesProps {
    onBack: () => void,
    selectedImages: any,
    setSelectedImages: (value: any) => void
    goToNextPage: () => void,
}

const UploadTicketImages: React.FC<UploadTicketImagesProps> = ({onBack, selectedImages, setSelectedImages, goToNextPage}) => {

    const handleFileChange = (event: any) => {
        const files = Array.from(event.target.files); // Convert FileList to Array
        const imageUrls = files.map((file: any) => ({
            file,
            preview: URL.createObjectURL(file), // Create preview URL
            sizeMB: (Math.floor((file.size / (1024 * 1024)) * 10000) / 10000).toFixed(4)  // Convert bytes to MB
        }));

        setSelectedImages((prevImages: any) => [...prevImages, ...imageUrls]);
    };

    const removeImage = (index: number) => {
        setSelectedImages(selectedImages.filter((_: any, i: number) => i !== index));
    };

    return (
        <div>
            <div className="clients-info-view-header">
                <button onClick={onBack}>REGRESAR</button>
                <div className="clients-info-view-header-title">
                    <p>ADJUNTAR FOTOS</p>
                </div>
            </div>
            <div className="upload-container">
                <div className="upload-buttons-container">
                    <label htmlFor="file-upload" className="custom-file-label">
                        Seleccionar imágenes
                    </label>
                    <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleFileChange}
                        className="file-input"
                    />
                    <button className="upload-images-next-button" onClick={goToNextPage}>
                        Siguiente
                    </button>
                </div>
                <div className="image-preview-container">
                    {selectedImages.map((img: any, index: number) => (
                        <div key={index} className="image-wrapper">
                            <img src={img.preview} alt="Selected" className="preview-image"/>
                            <p className="image-size-text">{img.sizeMB} MB</p> {/* Display File Size */}
                            <button onClick={() => removeImage(index)} className="remove-button">
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default UploadTicketImages;